import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { ClientsMarquee } from "@/components/ClientsMarquee";
import { Partners } from "@/components/PartnerBadges";
import { Services } from "@/components/Services";
import { ImpactDashboard } from "@/components/ImpactDashboard";
import { CaseStudies } from "@/components/CaseStudies";
import { WorkSamples } from "@/components/WorkSamples";
import { Testimonials } from "@/components/Testimonials";
import { BlogPreview } from "@/components/BlogPreview";
import { Seo } from "@/components/Seo";
import { CONTACT } from "@/data/site";

export default function Home() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <div className="App bg-ink">
      <Seo
        title="DNA eCommerce Ads — Amazon Ads, A+ Content & Performance Marketing"
        description="Performance-first Amazon Ads management, A+ content and full-funnel marketing. ROAS up to 11.4x, 1 Lakh+ products sold."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "DNA eCommerce Ads",
          url: origin,
          logo: `${origin}/dna-logo.png`,
          description: "Performance-first Amazon Ads agency — Amazon Ads management, A+ content and full-funnel marketing.",
          email: CONTACT.email,
          telephone: CONTACT.phoneHref,
          sameAs: ["https://advertising.amazon.com"],
        }}
      />
      <Header />
      <main>
        <Hero />
        <ClientsMarquee />
        <Partners />
        <Services />
        <ImpactDashboard />
        <CaseStudies />
        <WorkSamples />
        <Testimonials />
        <BlogPreview />
      </main>
      <Footer />
    </div>
  );
}
